import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  border-radius: ${(props) => props.theme.layout.default.radius};
  padding ${(props) => props.theme.layout.default.spacing};
  background: ${(props) => props.theme.foreground};
  border: 1px solid ${(props) => props.theme.border};
`;
